import Cookies from "js-cookie";
import React from "react";
import { Outlet } from "react-router-dom";
import { ThemeProvider } from "web-ui";
import InternalRootThemeProvider from "web-ui/components/internal/RootThemeProvider";
import { COLORS } from "web-ui/util/color";

import styles from "./App.module.scss";
import type { User } from "./api/v2";
import { apiV2 } from "./api/v2";
import { Error } from "./components/Error";
import TopBar from "./components/TopBar";
import { parseJwt } from "./util/auth";
import { Cookie } from "./util/cookies";

const App = () => {
  const [hasAttemptedLoadUser, setHasAttemptedLoadUser] = React.useState(false);
  const [user, setUser] = React.useState<User>();

  React.useEffect(() => {
    const jwt = Cookies.get(Cookie.Jwt);
    if (jwt) {
      (async () => {
        const userId = Number(parseJwt(jwt).payload.sub);
        const apiUser = await apiV2.getUser(userId);
        setUser(apiUser);
        setHasAttemptedLoadUser(true);
      })();
    } else {
      setHasAttemptedLoadUser(true);
    }
  }, []);

  // Since the user will be undefined while we wait to check the JWT, we need to
  // wait until we've loaded the user before rendering the app or else the logged-out
  // experience briefly flashes even for logged-in, authorized users.
  return hasAttemptedLoadUser ? (
    <InternalRootThemeProvider theme="light">
      <ThemeProvider colors={COLORS} theme="light">
        {({ style }) => (
          <div className={styles["app"]} style={style}>
            {user?.roles.includes("admin") ||
            user?.roles.includes("tts-data-contributor") ? (
              <>
                <TopBar />
                <div className={styles["content"]}>
                  <Outlet />
                </div>
              </>
            ) : (
              <Error subject="You do not currently have permission to view this page. Ensure you are signed in at duolingo.com." />
            )}
          </div>
        )}
      </ThemeProvider>
    </InternalRootThemeProvider>
  ) : null;
};

export default App;
